module.exports = __webpack_public_path__ + "img/max-file-search--zip.19d273dc.svg";